export default __webpack_public_path__ + "static/silverMCover-8912c7a547548aeee310f3650c156138.png";